import { render, staticRenderFns } from "./DadSucursales.vue?vue&type=template&id=f1fda018&scoped=true"
import script from "./DadSucursales.vue?vue&type=script&lang=js"
export * from "./DadSucursales.vue?vue&type=script&lang=js"
import style0 from "./DadSucursales.vue?vue&type=style&index=0&id=f1fda018&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_css-loader@6.11.0_webpack@5.97.1__lodash@4.17.21__nkjjb5puplgtn2g67cuu4wxlfy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1fda018",
  null
  
)

export default component.exports